export default __webpack_public_path__ + "static/media/info-icon.39c3e68d.svg";